<script setup lang="ts">
import LegacyProgressBar from '@/components/current-student-advanced-standing-form/shared/LegacyProgressBar.vue'
import type { LegacyClassBinding } from '@/components/current-student-advanced-standing-form/shared/types'

defineProps<{
  agreementChecked: boolean
  progressVisible: boolean
  progressClass: LegacyClassBinding
  progressMessage: string
  errorMessage: string
  buttonText: string
  buttonDisabled: boolean
}>()

defineEmits<{
  'update:agreementChecked': [checked: boolean]
  submit: []
}>()
</script>

<template>
  <legend>Submission</legend>
  <p>Your Advanced Standing application will now be submitted for assessment.</p>
  <div class="form-field requiredinput">
    <label>
      <input
        id="SubmissionAgreementInput"
        :checked="agreementChecked"
        type="checkbox"
        class="form-control"
        @change="$emit('update:agreementChecked', ($event.target as HTMLInputElement).checked)"
      >
      <br>
      I acknowledge that I have read and understood the information stated on this form and certify that the information provided on this form is, to the best of my knowledge, complete and correct.<br>
      I understand and accept that the University will designate courses where there is only admission into Year 1 of the course. In these cases, there is limited Advanced Standing.
    </label>
  </div>
  <LegacyProgressBar
    id="submitProgress"
    :visible="progressVisible"
    :bar-class="progressClass"
    :message="progressMessage"
  />
  <div class="alert alert-danger" id="SendErrorMessageBox">{{ errorMessage }}</div>
  <button
    class="btn btn-success"
    :disabled="buttonDisabled"
    id="submitBtn"
    type="button"
    @click="$emit('submit')"
  >
    {{ buttonText }}
  </button>
</template>
